import "./scss/application.scss";
import "bootstrap";
import React from "react";
import { createRoot } from 'react-dom/client';
import { Application } from "./Application";
const container = document.getElementById('root');
const root = createRoot(container);
root.render(React.createElement(Application, null));
